import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/inside";
import graphqlCmlink from "@/http/graphql/link";

const GET_POSTS = `
	posts (limit: $limit, page: $page, is_feature: $is_feature) {
		...Posts
	}
`;

const ADD_POST = `
	post (content: $content, category: $category, people: $people, files: $files) {
		...Post
  	}
`;

const UPDATE_POST = `
	update_post (id: $id, content: $content, category: $category, people: $people, files: $files) {
		...Post
  	}
`;

const DELETE_POST = `
	delete_post (post_id: $post_id)
`;

const TOGGLE_LIKE_POST = `
	post_interactive(post_id: $post_id, interactive_id: 1)
`;

const GET_GUIDE_CATEGORIES = `
	categories (model_name: $model_name, cluster_id: $cluster_id) {
		id
		title
		feature_image
	}
`;

const GET_GUIDE_POSTS = `
	posts (limit: $limit, page: $page, category_id: $category_id, cluster_id: $cluster_id) {
		data {
			id
			title
			brief
			content
			published_at
			updated_at
			documents{
				file_name
				path
			   }
		  
		  }
		  total
		  last_page
		
	}
`;

const APPELLATIONS = `
appellations {
    appellation
    employee {
      id
      name
      avatar(w: 300, h: 300)
    }
}`;

export default {
	init() {},

	getPosts(payload = {}) {
		const queryOptions = {
			query: gql`query Posts ($limit: Int, $page: Int, $is_feature: Boolean) {
				${GET_POSTS}
			}
			${fragments.Post}
			${fragments.Posts}
		`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				is_feature: payload.is_feature || false
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => ({ posts: response.data.posts }));
	},

	addPost(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation AddPost ($content: String, $category: Int, $people: [Int], $files: [Int]) {
					${ADD_POST}
				}
				${fragments.Post}
			`,
				variables: {
					content: payload.content,
					category: payload.category,
					files: payload.files,
					people: payload.people
				}
			})
			.then(response => response.data.post);
	},

	updatePost(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdatePost ($id: Int!, $content: String, $category: Int, $people: [Int], $files: [Int]) {
					${UPDATE_POST}
				}
				${fragments.Post}
			`,
				variables: {
					id: payload.id,
					files: payload.files,
					people: payload.people,
					content: payload.content,
					category: payload.category
				}
			})
			.then(response => response.data.update_post);
	},

	deletePost(postId) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DeletePost ($post_id: Int) {
					${DELETE_POST}
				}
			`,
				variables: {
					post_id: postId
				}
			})
			.then(response => response.data);
	},

	toggleLikePost(postId) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ToggleLikePost ($post_id: Int) {
					${TOGGLE_LIKE_POST}
				}
			`,
				variables: {
					post_id: postId
				}
			})
			.then(response => response.data);
	},

	getGuideCategories(payload = {}) {
		const queryOptions = {
			query: gql`query GuideCategories ($model_name: String, $cluster_id: Int) {
				${GET_GUIDE_CATEGORIES}
			}
			
		`,
			variables: {
				model_name: payload.model_name || "CmlinkPost",
				cluster_id: payload.cluster_id || 0
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => ({ categories: response.data.categories }));
	},
	getGuidePosts(payload = {}) {
		const queryOptions = {
			query: gql`query GuidePosts ($limit: Int!, $page: Int!, $category_id: Int, $cluster_id: Int ) {
				${GET_GUIDE_POSTS}
			}
			
		`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				category_id: payload.category_id || -1,
				cluster_id: payload.cluster_id || 0
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlCmlink.query(queryOptions).then(response => ({ posts: response.data.posts.data }));
	},

	getAppellations() {
		const queryOptions = {
			query: gql`query Appellations {
				${APPELLATIONS}
			}
			
		`
		};
		return graphqlClient.query(queryOptions).then(response => ({ appellations: response.data.appellations }));
	}
};
